const DAYS_IN_WEEK = 7;

const getPlanDiscountPercent = ({ price, trial, displayOldPrice }) => {
    const oldPrice = displayOldPrice ?? price;
    const newPrice = trial?.price ?? price;

    if (oldPrice === newPrice) {
        return 0;
    }

    return Math.round((1 - Number.parseFloat(newPrice.slice(1)) / Number.parseFloat(oldPrice.slice(1))) * 100);
};

const getPlanSaveLabel = ({ price, trial, displayOldPrice }) => {
    const oldPrice = displayOldPrice ?? price;
    const newPrice = trial?.price ?? price;
    const saved = Math.round((Number.parseFloat(oldPrice.slice(1)) - Number.parseFloat(newPrice.slice(1))) * 100) / 100;

    if (saved <= 0) {
        return null;
    }

    return `$${Number.isInteger(saved) ? saved : saved.toFixed(2)}`;
};

const getBillingDays = ({ unit, value } = {}) => {
    return unit === 'day' ? Number(value) : Number(value) * DAYS_IN_WEEK;
};

const getPricePerDayLabel = subscriptionData => {
    const cents = subscriptionData.trial?.pricePerDay ?? subscriptionData.pricePerDay;

    return `$${(cents / 100).toFixed(2)}`;
};

export {
    getPlanDiscountPercent,
    getPlanSaveLabel,
    getBillingDays,
    getPricePerDayLabel
};
